export const getStatusColor = (status: string) => {
    switch (status) {
        case "locked":
            return "tw-text-purple-600";
        case "approved":
            return "tw-text-lime-600";
        case "submitted":
            return "tw-text-rose-600";
        default:
            return "tw-text-primary"
    }
}
